import ChatDetail from './ChatDetail';

export default ChatDetail;
